export const SminexClubGroup = 'SminexClub';
export const CBGroup = 'CB';
export const SMINEX_CLUB_PERMISSION = 'sminex_club';
